import React, { useContext } from "react";
import NextLink from "next/link";
import CheckoutButton from "./checkoutbutton";
import { CheckoutContext } from "../lib/CheckoutContext";

export default function CreditsUI(props) {
    let id_append = props.id_append || "1";
    const { setQuantity, quantity } = useContext(CheckoutContext);
    // let ui_location = props.ui_location || uiLocation;

    function incrementInput() {
        const input = document.getElementById(`credits-input-${id_append}`);
        const navbarInput = document.getElementById(`credits-input`);
        let tmp = parseInt(input.value) + 1;
        input.value = tmp;
        navbarInput.value = tmp;
        const totalText = document.getElementById(`total-text-${id_append}`);
        setQuantity(tmp);
        totalText.innerHTML = `Total: $${tmp}`;
    }

    function decrementInput() {
        const input = document.getElementById(`credits-input-${id_append}`);
        const navbarInput = document.getElementById(`credits-input`);
        let tmp = parseInt(input.value) - 1;
        input.value = tmp;
        navbarInput.value = tmp;
        const totalText = document.getElementById(`total-text-${id_append}`);
        setQuantity(tmp);
        totalText.innerHTML = `Total: $${tmp}`;
    }

    function onInputChange() {
        const input = document.getElementById(`credits-input-${id_append}`);
        const navbarInput = document.getElementById(`credits-input`);
        const totalText = document.getElementById(`total-text-${id_append}`);
        setQuantity(input.value);
        navbarInput.value = input.value;
        totalText.innerHTML = `Total: $${input.value}`;
    }

    // function openCheckout() {
    //     
    //     props.setCheckoutOpen(true);
    // }
    return (
        <div className="card-body mt-3">            
            <div className="flex flex-col justify-around">              
             
                <div className="flex flex-col md:flex-row md:justify-between">
                <div className="md:max-w-[50%] dark:text-white">                
                    <h1 className="hidden md:block md:text-3xl lg:text-4xl font-bold mb-5">Buy Credits</h1>  
                    <h4 className="font-semibold">Credits can be used for <br/>advanced features:</h4>
                    <ul class="mt-4 space-y-3 text-black dark:text-gray-200">
                        <li class="flex items-center gap-2">
                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 24 24" className="w-5 h-5 mr-2 text-amber-500 shrink-0"><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm4.24 16L12 15.45 7.77 18l1.12-4.81-3.73-3.23 4.92-.42L12 5l1.92 4.53 4.92.42-3.73 3.23L16.23 18z"/></svg>
                          <NextLink href="/face_analyzer/eye_shape">AI Eye Shape Analyzer</NextLink>
                        </li>{" "}
                        <li class="flex items-center gap-2">
                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 24 24" className="w-5 h-5 mr-2 text-amber-500 shrink-0"><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm4.24 16L12 15.45 7.77 18l1.12-4.81-3.73-3.23 4.92-.42L12 5l1.92 4.53 4.92.42-3.73 3.23L16.23 18z"/></svg>
                          <NextLink href="/makeup-recommendations/nose-contour">Live Nose Contour Guides</NextLink>
                        </li>{" "}
                      </ul>                    
                </div>
                <div className="my-3 md:hidden block border-t-2 border-gray-300 w-full self-center"></div>
                <div className="w-fit h-full self-center">
                <h1 className="text-xl font-bold md:hidden">Buy Credits</h1>  
                    <div className="flex flex-row items-center ">                    
                        <h4 className="text-lg font-semibold mt-2">Quantity</h4>
                        {/* [--tooltip-offset:1rem] */}
                        <div
                            data-tip={
                                "Your credits can be used for advanced features: \n• Eye Shape Analyzer                                      \n• Nose Contour Guide                                     "
                            }
                            className="tooltip tooltip-bottom md:tooltip-left  before:whitespace-pre before:content-[attr(data-tip)] before:translate-x-[-75%] md:before:translate-x-0 md:before:translate-y-[-50%]"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                                className="w-4 h-4 ml-2 text-slate-600"
                            >
                                <path
                                    fillRule="evenodd"
                                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a.75.75 0 000 1.5h.253a.25.25 0 01.244.304l-.459 2.066A1.75 1.75 0 0010.747 15H11a.75.75 0 000-1.5h-.253a.25.25 0 01-.244-.304l.459-2.066A1.75 1.75 0 009.253 9H9z"
                                    clipRule="evenodd"
                                />
                            </svg>
                        </div>
                    </div>
                    <p className="text-xs text-gray-500 mb-2">$1 per credit</p>
                    <div className="form-control">
                        <div className="flex flex-row h-8 mb-2">
                            <button
                                id={`minus-credits-${id_append}`}
                                className="h-8 rounded-l bg-indigo-600 px-1 text-white"
                                onClick={decrementInput}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth={1.5}
                                    stroke="currentColor"
                                    className="w-4 h-[inherit]"
                                >
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M20 12H4" />
                                </svg>
                            </button>
                            <input
                                id={`credits-input-${id_append}`}
                                type="numeric"
                                defaultValue={quantity}
                                className="text-center h-8 w-full input input-primary input-bordered rounded-none"
                                onChange={onInputChange}
                            />
                            <button
                                id={`plus-credits-${id_append}`}
                                className="h-8 rounded-r bg-indigo-600 px-1 text-white"
                                onClick={incrementInput}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth={1.5}
                                    stroke="currentColor"
                                    className="w-4 h-[inherit]"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                                    />
                                </svg>
                            </button>
                        </div>
                    </div>
                    <div>
                        <p
                            id={`total-text-${id_append}`}
                            className="text-sm font-bold text-black dark:text-white mb-1"
                        >
                            Total: $
                            {quantity}
                        </p>
                    </div>
                    <CheckoutButton inputId={"credits-input-" + id_append}/>
                    {/* <button onClick={() => setCheckoutOpen(true)} className="inline-flex items-center justify-center w-full px-10 py-1 text-base font-medium text-white transition-all duration-200 bg-emerald-600 border-transparent rounded-xl hover:bg-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500">
                    Checkout
                    </button>                     */}
                    <NextLink href="/pricing" className="text-xs link link-hover text-blue-500 mt-2">What is a credit?</NextLink>
                </div>
                </div>         
            </div>
        </div>
    );
}
